import { getInstance } from './use-auth0';

// eslint-disable-next-line consistent-return
export default function authGuard(callback) {
  // eslint-disable-next-line consistent-return
  return (to, from, next) => {
    const authService = getInstance();

    // If loading has already finished, check our auth state using `fn()`
    if (!authService.loading) {
      return callback(authService, to, from, next);
    }

    // Watch for the loading property to change before we check isAuthenticated
    // eslint-disable-next-line consistent-return
    authService.$watch('loading', (loading) => {
      if (loading === false) {
        return callback(authService, to, from, next);
      }
    });
  };
}
